const { default: Vue } = require("vue");

Vue.component("form-list-component", require("./Index.vue").default);

Vue.component("form-create-component", require("./Create.vue").default);

Vue.component("form-manage-component", require("./ManageForm.vue").default);

Vue.component("form-component", require("./Form.vue").default);

Vue.component("form-report-component", require("./Report.vue").default);
